import React from 'react';

export const TitleContext = React.createContext({
  updateTitle: (title) => {},
});
